import { useCallback, useState } from 'react'

import { useDeleteAction } from 'data/hooks/actions'

type UseDeleteActionConfirmModalStateOptions = {
    action?: ActionDto
    onOpenChange?: (open: boolean) => void
}

export function useDeleteActionConfirmModalState(options: UseDeleteActionConfirmModalStateOptions) {
    const { action, onOpenChange } = options

    const [isError, setIsError] = useState(false)

    const handleOpenChange = useCallback(
        (isOpen: boolean) => {
            setIsError(false)
            onOpenChange?.(isOpen)
        },
        [onOpenChange]
    )

    const { mutateAsync: deleteAction } = useDeleteAction()
    const onDelete = useCallback(async () => {
        const actionSid = action?._sid
        if (!actionSid) return

        try {
            await deleteAction({ id: actionSid })

            handleOpenChange(false)
        } catch {
            setIsError(true)
        }
    }, [deleteAction, handleOpenChange, action])

    const actionName = action?.name

    return {
        onDelete,
        isError,
        handleOpenChange,
        actionName,
    }
}
